<template>
  <div
    :class="[$style.toggle_box, isToggleOn ? $style.on : null, isDisabled ? $style.disabled : null]"
    @click="toggle"
  >
    <div :class="$style.switch" />
  </div>
</template>

<script>

export default {
  props: {
    isToggleOn: {
      type: Boolean,
      required: true,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: [
    'onChange',
  ],
  methods: {
    toggle() {
      this.$emit('onChange');
    },
  },
};
</script>

<style module lang="less" src='./less/toggle.less?module'></style>
